import type {VariableType} from '@wix/document-services-types'
import * as refArrayUtils from '../../../utils/refArrayUtils'
import type {
    ExtendedVariableValue,
    SerializedVariablesList,
    PresetsWithVariables,
    SerializedVariantRelation
} from '../types'

export interface IPresetsDataTransformer {
    normalizePresetsData(variablesData: SerializedVariablesList): PresetsWithVariables
}

export class PresetsDataTransformer implements IPresetsDataTransformer {
    normalizePresetsData(variablesData: SerializedVariablesList): PresetsWithVariables {
        return variablesData.variables
            .filter(v => !!v.name)
            .reduce<PresetsWithVariables>((presets, variable) => {
                const variantRelations = variable.value.values.filter(this.isVariantRelation)

                return variantRelations.reduce<PresetsWithVariables>((acc, relation) => {
                    if (!relation.variants || !relation.to) {
                        return acc
                    }

                    return relation.variants.reduce<PresetsWithVariables>((result, rawVariantId) => {
                        const variantId = refArrayUtils.stripHashIfExists(rawVariantId)

                        return variantId
                            ? this.addVariantToPresets(result, variantId, variable, relation.to.value)
                            : result
                    }, acc)
                }, presets)
            }, {})
    }

    private addVariantToPresets(
        presets: PresetsWithVariables,
        variantId: string,
        variable: {id: string; name: string; type: VariableType},
        value: any
    ): PresetsWithVariables {
        return {
            ...presets,
            [variantId]: {
                ...presets[variantId],
                [variable.name]: {
                    id: variable.id,
                    name: variable.name,
                    type: variable.type,
                    value
                }
            }
        }
    }

    private isVariantRelation(
        item: ExtendedVariableValue | SerializedVariantRelation
    ): item is SerializedVariantRelation {
        return item.type === 'VariantRelation'
    }
}
